import React, {useEffect, useState} from "react";
import {Routes, Route} from "react-router-dom";
import Header from "../components/header/Header";
import ScrollToHash from "../components/ScrollToHash";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Profile from "./profile/Profile";
import StartupProject from "./StartupProjects/StartupProject";
import SplashScreen from "./splashScreen/SplashScreen";
import BlogList from "./blog/BlogList";
import BlogDetail from "./blog/BlogDetail";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLogin from "./admin/AdminLogin";
import Resume from "./resume/Resume";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useSettings} from "../contexts/SettingsContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import Loader from "../components/loader/Loader";
import "./Main.scss";

const Portfolio = () => {
  const {isVisible, loaded} = useSettings();
  // Block initial paint of the portfolio (just the inner sections) until the
  // settings fetch has settled — success OR failure. SettingsContext guarantees
  // that on failure, `loaded` flips to true with full defaults applied, so the
  // user still sees every section.
  if (!loaded) return <Loader inline label="Rashid Ahmad" />;
  return (
    <>
      {isVisible("sections.greeting")   && <Greeting />}
      {isVisible("sections.skills")     && <Skills />}
      {isVisible("sections.techStack")  && <StackProgress />}
      {isVisible("sections.education")  && <Education />}
      {isVisible("sections.experience") && <WorkExperience />}
      {isVisible("sections.projects")   && <StartupProject />}
      {isVisible("sections.contact")    && <Profile />}
    </>
  );
};

const Main = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <ScrollToHash />
            <Routes>
              <Route path="/" element={<BlogList />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
